declare global {
  interface Window {
    /** Wenn true: globales Projekt-Upload-Overlay/Drop unterdrücken (z. B. Mail-Anhänge). */
    __ehSuppressGlobalUpload?: boolean;
  }
}

export function isGlobalUploadSuppressed(): boolean {
  return typeof window !== "undefined" && window.__ehSuppressGlobalUpload === true;
}

export function setGlobalUploadSuppressed(suppressed: boolean): void {
  if (typeof window === "undefined") return;
  if (suppressed) {
    window.__ehSuppressGlobalUpload = true;
  } else {
    delete window.__ehSuppressGlobalUpload;
  }
}
